import { z } from "zod";

import { ExperiencePageTargetingDtoSchema } from "../dtos/experience-page-targeting";

export const ExperiencePageTargetingFeSchema =
  ExperiencePageTargetingDtoSchema.extend({
    experienceId: z.string().uuid().optional(),
  });

export type ExperiencePageTargetingFe = z.infer<
  typeof ExperiencePageTargetingFeSchema
>;
